import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Button } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import JSONView from 'react-json-view';
import './AuditLogModal.css';

const { Text } = Typography;

@inject(
    'AuditLogStore'
)
@observer
class AuditLogModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    cancelAuditLogDetailOnClick = () => {
        this.props.AuditLogStore.setshowAuditLogModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            auditLog,
            auditLogModalLoading
        } = this.props.AuditLogStore;

        return (
            <>
                {
                    auditLog
                        ?
                        <>
                            <Spin spinning={auditLogModalLoading}>
                                <Row className='auditlogmodal-row-container'>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>{t('Area')}</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.area}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>{t('Action')}</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.action}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>{t('Username')}</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.username}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>{t('Created At')}</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input'>
                                                <span>{auditLog.createdDateString}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='auditlogmodal-col-label'>
                                                <Text className='auditlogmodal-text-label'>{t('Detail')}</Text>
                                            </Col>
                                            <Col span={16} className='auditlogmodal-col-input json-viewer'>
                                                <JSONView src={JSON.parse(auditLog.data)} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='auditlogmodal-col-button'>
                                        <Button type='primary' className='auditlogmodal-button' onClick={this.cancelAuditLogDetailOnClick}>{t('Close')}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(AuditLogModalPage);
